import { supabase } from '@/integrations/supabase/client';

/**
 * Fetches the CTM recording URL for a call log UUID and opens it in a new tab.
 * Returns an error message string if something went wrong, or null on success.
 */
export async function openRecording(callLogId: string): Promise<string | null> {
  const { data, error } = await supabase.functions.invoke('ctm-get-recording', {
    method: 'POST',
    body: { call_id: callLogId },
  });

  if (error) {
    // Supabase wraps non-2xx responses as FunctionsHttpError.
    // The actual message from the edge function is in error.context (a Response).
    try {
      const body = await (error as any).context?.json?.();
      return body?.error ?? error.message;
    } catch {
      return error.message;
    }
  }

  if (!data?.url) {
    return 'No recording URL returned';
  }

  window.open(data.url, '_blank', 'noopener,noreferrer');
  return null;
}
